module.exports = __webpack_public_path__ + "static/media/animal-dog3.7d2e4ceb.aac";